import { useLocalization } from '@/Hooks';

export const useContractLogisticTooltips = (selectedPackageKeys: { key: string; weight: string | number }[]) => {
  const {
    modalWindows: {
      orderLinkWithProduct: {
        ShippingContract: { ChoosePackageFirst, NoLogisticsForPackages },
      },
    },
  } = useLocalization();

  const selectedPackagesLength = selectedPackageKeys.filter((i) => i.key.length).length;

  const productTooltipMessage = selectedPackagesLength === 0 ? ChoosePackageFirst : NoLogisticsForPackages;

  return {
    productTooltipMessage,
  };
};
